import indexOf from 'lodash/indexOf';
import extend from 'lodash/extend';
import { TOGGLE_FAVORITE_PROCESS } from '../actions/storage';

export default function storage(
  state = {
    favorites: {
      processes: []
    }
  },
  action
) {
  let favorites;
  let existsAt;
  switch (action.type) {
    case TOGGLE_FAVORITE_PROCESS:
      favorites = state.favorites.processes;
      existsAt = indexOf(favorites, action.processID);

      if (existsAt !== -1) {
        favorites.splice(existsAt, 1);
      } else {
        favorites.push(action.processID);
      }

      return Object.assign({}, state, {
        favorites: extend(state.favorites, {
          processes: favorites
        })
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/storage.js